// src/pages/AddLessonPage.jsx
// import React from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import PropTypes from "prop-types";
// import EditLessonPage from "./EditLesson";

// const AddLessonPage = () => {
//   const { courseSlug } = useParams();
//   const navigate = useNavigate();

//   if (!courseSlug) {
//     navigate("/admin/courses", { replace: true });
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <p className="text-red-500 text-lg font-semibold">
//           Invalid route: course slug missing. Redirecting to courses...
//         </p>
//       </div>
//     );
//   }

//   return <EditLessonPage lessonId="add" courseSlug={courseSlug} />;
// };

// AddLessonPage.propTypes = {
//   courseSlug: PropTypes.string,
// };

// export default AddLessonPage;



import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EditLessonPage from "./EditLesson";

const AddLessonPage = () => {
  const { courseSlug } = useParams();
  const navigate = useNavigate();

  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (!courseSlug) {
      setIsValid(false);

      // Safe redirect after mount
      const timer = setTimeout(() => {
        navigate("/admin/courses", { replace: true });
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [courseSlug, navigate]);

  // UI shown only when slug is missing
  if (!isValid) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-red-500 text-lg font-semibold">
          Invalid route: course slug missing. Redirecting to courses...
        </p>
      </div>
    );
  }

  // Open lesson editor in ADD mode
  return (
    <EditLessonPage
      lessonId="add"
      courseSlug={courseSlug}
    />
  );
};

export default AddLessonPage;
